const messages = {
  "title": "Onderhoudswerk!",
  "description": "Er worden momenteel noodzakelijke onderhoudswerkzaamheden uitgevoerd op de servers.<br/><br/>Daarom heeft u momenteel geen toegang tot <b>BRIDGESTONE <span class=\"text-danger\">PLUS</span></b>.<br/><br/>Wij vragen om uw geduld en danken u voor uw begrip.<br/><br/>Uw Bridgestone-team",
  "desc": "Op dit moment voeren we noodzakelijke onderhoudswerkzaamheden uit aan onze servers.<br /><br />Voorlopig is de toegang tot <b>BRIDGESTONE <span class='text-danger'>PLUS</span></b> dan ook niet beschikbaar.<br /><br />Wij vragen om uw geduld en danken u voor uw begrip.<br /><br />Het Bridgestone Team"
};

export default {
  messages,
};
